import { lazy, Suspense } from "react";
import type { ReactNode } from "react";
import DialogHeader from "./footer/DialogHeader";
import DialogFooter from "./footer/DialogFooter";

const DialogOnlyWrapper = lazy(() => import("./DialogOnlyWrapper"));

interface DialogXlProps {
  open: boolean;
  handleClose: () => void;
  handleFooterSubmit?: () => void;
  children: ReactNode;
  title: string;
  subtitle: string;
  cancel?: string;
  submit?: string;
  requiredMessage?: string;
  showFooter?: boolean;
  onDeleteClick?: () => void;
  onResendClick?: () => void;
}

const DialogXl: React.FC<DialogXlProps> = ({
  open,
  handleClose,
  handleFooterSubmit,
  children,
  title,
  subtitle,
  cancel,
  submit,
  requiredMessage,
  showFooter = true,
}) => {
  if (!open) return null;

  return (
    <Suspense fallback={<div />}>
      <DialogOnlyWrapper>
        <div className="gx-dialog-box">
          <DialogHeader
            handleClose={handleClose}
            title={title}
            subtitle={subtitle}
          />
          <div className="gx-dialog-main">{children}</div>
          {showFooter && (
            <DialogFooter
              handleClose={handleClose}
              handleFooterSubmit={handleFooterSubmit}
              cancel={cancel}
              submit={submit}
              requiredMessage={requiredMessage}
            />
          )}
        </div>
      </DialogOnlyWrapper>
    </Suspense>
  );
};

export default DialogXl;